import React, {useState, useEffect, useContext} from 'react';
import { getUrlLocale, getCookie, setCookie } from 'components/utils/helper';
import { Container, Bar, Language, Close } from './LanguageBar.style';

import ConfigContext from 'context/ConfigContext';

const LanguageBar = () => {
    let config = useContext(ConfigContext);
    const [isActive, setIsActive] = useState(false);
    let {country, language} = getUrlLocale();

    useEffect(() => {
        let languageBarDisabled = getCookie('language-bar-is-disabled');
        let hasMultipleLanguages = config.getValue(["locale", country, "language"]) && config.getValue(["locale", country, "language"]).length > 1;
        if (!languageBarDisabled && hasMultipleLanguages){
            setIsActive(true);
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onSelectLanguage(code) {
        let redirectTo = window.location.pathname;
        if(code === 'en' && language !== 'en') {
            // Remove language part (i.e /fr ) in url
            if(redirectTo.charAt(3) === '/'){
                redirectTo = redirectTo.substr(3);
            }
        } else if(code !== 'en' && code !== language){
            if(language !== 'en'){
                redirectTo = redirectTo.substr(3);
            }
            redirectTo = `/${code}${redirectTo}`;
        }
        window.location = redirectTo;
        setIsActive(false);
        setCookie('language-bar-is-disabled', 'true', 30);
    }

    return ( 
        <Container isVisible={isActive}>
            <Bar>
                {config.getValue(["locale",country, "language"]) && config.getValue(["locale",country, "language"]).map((lang, index) =>
                    <Language key={index} 
                        isSelected={config.getLanguage() === lang.code}
                        onClick={() => onSelectLanguage(lang.code)}>
                            {lang.name}
                    </Language>
                )}
                <Close onClick={() => setIsActive(false)}/>
            </Bar>
        </Container>
    );
}
 
export default LanguageBar;